const baseRouter = '/api/';
const staticPages = 'StaticPages/';
const speaking = 'Speakings/';
const listening = 'Listenings/';
const writing = 'Writings/';
const reading = 'Readings/';
const learningTests = 'LearningTests/';

export const ApiRouters = {
	LOGIN: baseRouter + 'Auth/PortalLogin',
	FORGOT_PASSWORD: baseRouter + 'Auth/ForgotPassword',
	CHECK_TOKEN_RESET_PW: baseRouter + 'Auth/CheckResetPassword',
	RESET_PASSWORD: baseRouter + 'Auth/ResetPassword',

	ACCOUNT: baseRouter + 'Account',
	USER_LOGIN_PROFILE: baseRouter + 'Account/Profile',
	CHANGE_PASSWORD: baseRouter + 'Account/ChangePassword',

	CUSTOMER: baseRouter + 'Customers',
	CUSTOMER_TYPE: baseRouter + 'CustomerTypes',
	USER: baseRouter + 'Users',
	COMMON: baseRouter + 'Commons',
	ROLE: baseRouter + 'Groups',
	CAREER: baseRouter + 'Careers',
	SUBCRIPTIONPACKAGE: baseRouter + 'SubcriptionPackages',
	TOPIC: baseRouter + 'Topics',
	SENTENCE: baseRouter + 'Sentences',
	SENTENCEVOCAKEY: baseRouter + 'SentenceVocakeys',
	LEARNER: baseRouter + 'Learners',
	GRAMMARDESCRIPTION: baseRouter + 'GrammarDescriptions',
	STATICPAGE: baseRouter + 'StaticPages',
	SETTING: baseRouter + 'Settings',
	REPORT: baseRouter + 'Reports',
	IMPORT: baseRouter + 'Import',
	EXPORT: baseRouter + 'Export',
	NOTIFICATION: baseRouter + 'Notification',
	LEARNINGPROCESS: baseRouter + 'LearningProcess',
	DASHBOARD: baseRouter + 'Dashboard',
	DASHBOARD_BO: baseRouter + 'Dashboard/DashbroadBO',
	HOMEPAGE: baseRouter + 'HomePages',
	SUBSCRIPTIONREQUEST: baseRouter + 'LearnerSubscriptions',
	SUBSCRIPTIONTEACHERREQUEST: baseRouter + 'TeacherSubscriptions',
	TEACHER: baseRouter + 'Teachers',
	LEVEL: baseRouter + 'Levels',
	CLASS: baseRouter + 'Class',

	FAQs: baseRouter + staticPages + 'FrequentlyAskedQuestion',
	// SPEAKING
	READALOUD: baseRouter + speaking + 'ReadAloud',
	DESCRIBEIMAGE: baseRouter + speaking + 'DescribeImage',
	ANSWERSHORTQUESTION: baseRouter + speaking + 'AnswerShortQuestion',
	REPEATSENTENCE: baseRouter + speaking + 'RepeatSentence',
	RETELLLECTURE: baseRouter + speaking + 'RetellLecture',

	// WRITING
	SUMMARIZEWRITTENTEXT: baseRouter + writing + 'SummarizeWrittenText',
	WRITEESSAY: baseRouter + writing + 'WriteEssay',

	// URL Reading
	API_BLANKS_DROP_DOWN: baseRouter + reading + 'FillInBlanksDropdown',
	API_BLANKS_DRAG_DROP: baseRouter + reading + 'FillInBlanksDragAndDrop',
	API_REORDER_PARAGRAPH: baseRouter + reading + 'ReOrderParagraph',
	API_MULTIPLE_ANSWER: baseRouter + reading + 'MultipleChoiceMultipleAnswer',
	API_SINGLE_ANSWER: baseRouter + reading + 'MultipleChoiceSingleAnswer',

	// LISTENING
	SUMMARIZESPOKENTEXT: baseRouter + listening + 'SummarizeSpokenText',
	WRITEFROMDICTATION: baseRouter + listening + 'WriteFromDictation',
	MULTIPLECHOICEMULTIPLEANSWER: baseRouter + listening + 'MultipleChoiceMultipleAnswerListen',
	HIGHLIGHTCORRECTSUMMARY: baseRouter + listening + 'HighlightCorrectSummarize',
	FILLINTHEBLANKS: baseRouter + listening + 'FillInTheBlanks',
	MULTIPLECHOICESINGLEANSWER: baseRouter + listening + 'MultipleChoiceSingleAnswerListen',
	SELECTMISSINGWORD: baseRouter + listening + 'SelectMissingWord',
	HIGHLIGHTINCORRECTWORD: baseRouter + listening + 'HighlightIncorrectWord',

	//MOCK_TEST
	GET_SAMPLE_EXAM: baseRouter + learningTests + 'SampleExamForBo',
	GET_SAMPLE_EXAM_BY_ID: baseRouter + learningTests + 'SampleExam',
	DELETE_SAMPLE_EXAM: baseRouter + learningTests + 'SampleExam',
	POST_SAMPLE_EXAM: baseRouter + learningTests + 'SampleExam',
	PUT_SAMPLE_EXAM: baseRouter + learningTests + 'SampleExam',
	GET_QUESTION_FOR_CREATE: baseRouter + learningTests + 'SampleExam/ListQuestionForCreate',
	SPECIAL_STUDENTS_MOCKTEST: baseRouter + learningTests + 'SpecialStudentsInMockTest',

	//QnA
	GET_QNA: baseRouter + staticPages + 'FormSubmit',
	POST_QNA: baseRouter + staticPages + 'FormSubmit',
	GET_QNA_DETAIL: baseRouter + staticPages + 'FormSubmit',
	PUT_QNA: baseRouter + staticPages + 'FormSubmit',
	DELETE_QNA: baseRouter + staticPages + 'FormSubmit',
};
